/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".example-button-row[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .example-button-row[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:85%}.table-container[_ngcontent-%COMP%]{margin:20px;overflow:auto}table[_ngcontent-%COMP%]{width:100%}mat-paginator[_ngcontent-%COMP%]{margin-top:10px}"];
export { styles as styles };
